import Api from 'src/api/Base'

class PostSpaceType extends Api {
  requestUrl = `/api/SpaceType`

  method = 'POST'

  formatRequestData = params => params.spaceType
}
export default PostSpaceType
